// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Qv-z","tooltipWrapper":"Rv-z","icon":"Sv-z","tooltip":"Tv-z","content":"Uv-z"};